// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb[data-v-2da5bd18]{flex-grow:1;height:36px;padding:9px 0}ul[data-v-2da5bd18]{margin:0}li[data-v-2da5bd18],ul[data-v-2da5bd18]{align-items:center;display:-moz-flex;display:-ms-flex;display:-o-flex;display:flex}li.linked[data-v-2da5bd18]{cursor:pointer}li.linked[data-v-2da5bd18]:hover{color:#ff002a}li+li[data-v-2da5bd18]:before{content:\"/\";display:inline-block;margin:0 12px}.is_apple li+li[data-v-2da5bd18]:before{margin-bottom:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
